import { Icon, IconButton } from '@yembo/yemblocks-core';
import { ReactNode, useState } from 'react';

type CollapsibleNotificationProps = {
  className?: string;
  children?: ReactNode;
  width?: string;
  collapsedWidth?: string;
  height?: string;
};

export function CollapsibleNotification({ className = '', children }: CollapsibleNotificationProps): React.JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const renderCollapseButton = () => {
    return isCollapsed ? (
      <div className='maximize'>
        <IconButton kind='flat' icon={<Icon name='add' />} onClick={() => setIsCollapsed(false)} />
      </div>
    ) : (
      <div className='minimize'>
        <IconButton kind='flat' icon={<Icon name='minus' />} onClick={() => setIsCollapsed(true)} />
      </div>
    );
  };

  return (
    <div className={`yb-collapsible-notification ${className} ${isCollapsed ? 'collapsed' : ''}`}>
      <div className={'children-wrapper'}>{children}</div>
      {renderCollapseButton()}
    </div>
  );
}

export function Collapsible(props: { children: ReactNode }): React.JSX.Element {
  return <div className='collapsible-container'>{props.children}</div>;
}
